import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  GonvarriQuickStockTitleModalComponent
} from "../../components/gonvarri-quick-stock-title-modal/gonvarri-quick-stock-title-modal.component";
import {CmsConfig, I18nModule, provideConfig, provideDefaultConfig} from "@spartacus/core";
import {GonvarriAddToCartModule} from "../gonvarri-add-to-cart/gonvarri-add-to-cart.module";
import {GonvarriChapaQuantityModule} from "../gonvarri-chapa-quantity/gonvarri-chapa-quantity.module";
import {FormsModule} from "@angular/forms";
import {IconModule} from "@spartacus/storefront";
import {gonvarriDefaultAddedToCartLayoutConfig} from "../../layouts/added-to-cart-layout-config";
import {RouterLink} from "@angular/router";

@NgModule({
  declarations: [
    GonvarriQuickStockTitleModalComponent
  ],
    imports: [
        CommonModule,
        GonvarriAddToCartModule,
        I18nModule,
        GonvarriChapaQuantityModule,
        FormsModule,
        IconModule,
        RouterLink
    ],
  exports: [
    GonvarriQuickStockTitleModalComponent
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GonvarriQuickStockTitleModalComponent: {
          component: GonvarriQuickStockTitleModalComponent
        },
      }
    }),
    provideDefaultConfig(gonvarriDefaultAddedToCartLayoutConfig)
  ]
})
export class GonvarriQuickStockTitleModalModule { }
